import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Adherent } from '../shared/interfaces/BDD-Ref/adherent';
import { UserSessionService } from '../shared/services/user.service';
import { ConfigService } from '../shared/services/core/config.service';
import { ButtonLinkListComponent } from '../shared/components/button-link-list/button-link-list.component';
import { filter, Subject, takeUntil, tap } from 'rxjs';
import { MatToolbar } from '@angular/material/toolbar';

@Component({
  selector: 'app-accueil',
  templateUrl: './accueil.component.html',
  styleUrl: './accueil.component.scss',
  standalone: true,
  imports: [MatToolbar, ButtonLinkListComponent],
})
export class AccueilComponent implements OnInit {
  private readonly _destroying$ = new Subject<void>();
  formSelect: FormGroup;
  adherents: Adherent[] = [];
  firstname = '';
  lastname = '';
  selectedAdherent: Adherent | null = null;
  user: any;
  bienvenueString = 'Bienvenue sur la Plateforme Adhérent LafSanté.';
  bienvenueStringGPO = 'Bienvenue sur la Plateforme Adhérent.';
  bonjourString = 'Bonjour';
  PilotageString = 'Pilotage';
  AnimationCommercialesString: string = 'Animations Commerciales';
  SuiviConditionsCommercialesString: string = 'Suivi des conditions commerciales';
  autresOutilsString = 'Autres outils';
  adminString = 'Administration';
  activiteAdherent: string = '';

  linkToPageButtonsPilotage: {
    name: string;
    img: string;
    link: string;
    authorizeGroup: string;
    tooltipMessage?: string;
  }[] = [
    {
      name: 'Cockpit',
      img: './assets/icons/picto-cockpit-vert-plateforme-adherents.svg',
      link: '/cockpit',
      authorizeGroup: 'pfa.piloter-cockpit',
      tooltipMessage: 'Je dispose de l’ensemble des indicateurs clefs de mon officine.',
    },
    {
      name: 'Cockpit',
      img: './assets/icons/picto-cockpit-vert-plateforme-adherents.svg',
      link: '/cockpit',
      authorizeGroup: 'pfa-gpo.piloter-cockpit',
      tooltipMessage: 'Je dispose de l’ensemble des indicateurs clefs de mon officine.',
    },
    {
      name: 'Cockpit Optique',
      img: './assets/icons/picto-cockpit-optique-vert.svg',
      link: '/cockpit/optique',
      authorizeGroup: 'pfa-opt.piloter-cockpit',
      tooltipMessage: "Je dispose de l’ensemble des indicateurs clefs de mon magasin d'optique.",
    },
    {
      name: 'Marge',
      img: './assets/icons/picto-pilotage-vert-plateforme-adherents.svg',
      link: '/marge',
      authorizeGroup: 'pfa.piloter-marge',
      tooltipMessage: 'Je pilote la marge de mon officine.',
    },
    {
      name: 'Rentabilité Linéaire',
      img: './assets/icons/picto-rentabilite-vert-plateforme-adherents.svg',
      link: '/rentabilitelineaire',
      authorizeGroup: 'pfa.piloter-rentabilite-lineaire',
      tooltipMessage: 'Je pilote le CA et la marge par descente et par catégorie.',
    },
    {
      name: 'Ventes',
      img: './assets/icons/picto-vente-vert-plateforme-adherents.svg',
      link: '/ventes',
      authorizeGroup: 'pfa.piloter-ventes',
      tooltipMessage: 'Je pilote les données de ventes de mon officine.',
    },
    {
      name: 'Stock',
      img: './assets/icons/picto-pilotage-stock-vert-plateforme-adherents.svg',
      link: '/stock',
      authorizeGroup: 'pfa.piloter-stocks',
      tooltipMessage: 'Je pilote les informations sur le stock de mon officine.',
    },
    {
      name: 'Ranking',
      img: './assets/icons/picto_ranking.svg',
      link: '/ranking',
      authorizeGroup: 'pfa.piloter-ranking',
      tooltipMessage: 'Je suis l’évolution du CA de mon officine par rapport au réseau.',
    },
    {
      name: 'Fidélité officine',
      img: './assets/icons/picto_performances de la fidelite.svg',
      link: '/pilotagefideliteofficine',
      authorizeGroup: 'pfa.piloter-fidelite-officine',
      tooltipMessage: 'Je suis les indicateurs de fidélité de mon officine.',
    },
    {
      name: 'Fidélité client',
      img: './assets/icons/picto_fidelite-client.svg',
      link: '/pilotagefideliteclient',
      authorizeGroup: 'pfa.piloter-fidelite-client',
      tooltipMessage: 'Je connais les clients fidélité de mon officine.',
    },
    {
      name: 'Pricing',
      img: './assets/icons/picto_pricing.svg',
      link: '/pilotagepricing',
      authorizeGroup: 'pfa.piloter-pricing',
      tooltipMessage: 'Je pilote les informations sur pricing.',
    },
    {
      name: 'Opérateurs',
      img: './assets/icons/picto_pilotage des operateurs.svg',
      link: '/operateurs',
      authorizeGroup: 'pfa.piloter-operateurs',
      tooltipMessage: 'Je suis la performance de chaque opérateur.',
    },
    {
      name: 'Mex',
      img: './assets/icons/picto_mex.svg',
      link: '/mex',
      authorizeGroup: 'pfa.piloter-mex',
      tooltipMessage: 'Je suis la performance des Marques Exclusives de mon officine.',
    },
    {
      name: 'Services de Santé',
      img: './assets/icons/picto-services-sante-vert.svg',
      link: '/pilotageservicedesante',
      authorizeGroup: 'pfa.piloter-service-sante',
      tooltipMessage: 'Je pilote mes services de santé.',
    },
    {
      name: 'Biosimilaires',
      img: './assets/icons/picto_biosimilaires-vert.svg',
      link: '/biosimilaires',
      authorizeGroup: 'pfa.piloter-biosimilaires',
      tooltipMessage: 'Je pilote mes biosimilaires.',
    },
    {
      name: 'Génériques',
      img: './assets/icons/picto_generiques-vert.svg',
      link: '/generiques',
      authorizeGroup: 'pfa.piloter-generiques',
      tooltipMessage: 'Je pilote mes génériques.',
    },
  ];

  linkToPageButtonsSuiviConditionsCommerciales: {
    name: string;
    img: string;
    link: string;
    authorizeGroup: string;
    tooltipMessage?: string;
    external?: boolean;
  }[] = [
    {
      name: 'Simulation générique',
      img: './assets/icons/picto-remises-generiqueurs-vert-plateforme-adherents.svg',
      link: '/simulation-generique',
      authorizeGroup: 'pfa.remise-generique',
      tooltipMessage: 'Je calcule le montant des remises génériques dont je bénéficie.',
    },
    {
      name: 'Simulation générique',
      img: './assets/icons/picto-remises-generiqueurs-vert-plateforme-adherents.svg',
      link: '/simulation-generique',
      authorizeGroup: 'pfa-gpo.remise-generique',
      tooltipMessage: 'Je calcule le montant des remises génériques dont je bénéficie.',
    },
    {
      name: 'Simulation grossiste',
      img: './assets/icons/picto-remises-grossistes-vert-plateforme-adherents.svg',
      link: '/simulation-grossiste',
      authorizeGroup: 'pfa.remise-grossiste',
      tooltipMessage: 'Je calcule le montant des remises grossistes dont je bénéficie.',
    },
    {
      name: 'Simulation grossiste',
      img: './assets/icons/picto-remises-grossistes-vert-plateforme-adherents.svg',
      link: '/simulation-grossiste',
      authorizeGroup: 'pfa-gpo.remise-grossiste',
      tooltipMessage: 'Je calcule le montant des remises grossistes dont je bénéficie.',
    },
    {
      name: 'Pilotage Accords Commerciaux',
      img: './assets/icons/picto-pilotage-rfa-vert-plateforme-adherents.svg',
      link: '', // URL GESTAC injectée depuis la configuration dans ngOnInit
      authorizeGroup: 'pfa.pilotage-accords-commerciaux',
      tooltipMessage: 'Je calcule et pilote le suivi de mes RFA / COOPS labos.',
      external: true,
    },
    {
      name: 'Laboratoires',
      img: './assets/icons/picto_suivi laboratoires.svg',
      link: '/suivilabo',
      authorizeGroup: 'pfa.piloter-suivi-labo',
      tooltipMessage: 'Je dispose des informations sur mes laboratoires partenaires.',
    },
  ];

  linkToPageButtonsAnimationsCommerciales: {
    name: string;
    img: string;
    link: string;
    authorizeGroup: string;
    tooltipMessage?: string;
  }[] = [
    {
      name: 'Promotions',
      img: './assets/icons/picto-pilotage-trade-vert-plateforme-adherents.svg',
      link: '/promotions',
      authorizeGroup: 'pfa.piloter-promotion',
      tooltipMessage: 'Je pilote la politique promotionnelle de mon officine.',
    },
    {
      name: 'Trade Laf',
      img: './assets/icons/picto-pilotage-trade-vert-plateforme-adherents.svg',
      link: '/trade',
      authorizeGroup: 'pfa.piloter-trade',
      tooltipMessage: 'Je pilote la politique promotionnelle de mon officine.',
    },
  ];

  linkToPageButtonsAdmin: {
    name: string;
    img: string;
    link: string;
    authorizeGroup: string;
    tooltipMessage?: string;
  }[] = [
    {
      name: 'Gestion des comptes',
      img: './assets/icons/picto-gestion-des-comptes-vert.svg',
      link: '/gestioncomptes',
      authorizeGroup: 'pfa.administrer-gestion-comptes',
      tooltipMessage: 'Je gère les comptes utilisateurs de mon officine',
    },
    {
      name: 'Gestion des comptes',
      img: './assets/icons/picto-gestion-des-comptes-vert.svg',
      link: '/gestioncomptes',
      authorizeGroup: 'pfa-gpo.administrer-gestion-comptes',
      tooltipMessage: 'Je gère les comptes utilisateurs de mon officine',
    },
    {
      name: 'Mes Autorisations',
      img: './assets/icons/picto_mes-authorisations-vert.svg',
      link: '/gestionautorisations',
      authorizeGroup: 'pfa-gpo.administrer-autorisations',
      tooltipMessage: 'Je gère les autorisations',
    },
  ];

  externalLinkButtons: {
    name: string;
    img: string;
    link: string;
    authorizeGroup: string;
    tooltipMessage?: string;
  }[] = [
    {
      name: 'Laf Connect',
      img: '',
      link: 'https://lafconnect.workvivo.com/login',
      authorizeGroup: 'pfa.autres-outils',
      tooltipMessage: 'Outil de communication',
    },
    {
      name: 'Accords commerciaux',
      img: '',
      link: 'https://accords.pharmacielafayette.com/',
      authorizeGroup: 'pfa.autres-outils',
      tooltipMessage: 'Etat des conditions par labos',
    },
    {
      name: 'MyLafayette',
      img: './assets/images/logo-mylafayette.png',
      link: 'https://mylafayette.fr/',
      authorizeGroup: 'pfa.autres-outils',
      tooltipMessage: '	Intranet',
    },
    {
      name: 'LafServices',
      img: './assets/images/logo-lafservices.png',
      link: 'https://app-lafpcp-prd.azurewebsites.net/login',
      authorizeGroup: 'pfa.autres-outils',
      tooltipMessage: 'Plateforme de paiement',
    },
    {
      name: 'FACT',
      img: './assets/images/logo-fact.png',
      link: 'https://dub01.online.tableau.com/t/promoscan/views/LAFESCANPILOTAGEPRIX-V1/1_INDICESPRIX',
      authorizeGroup: 'pfa.autres-outils',
      tooltipMessage: 'Outil de suivi des prix vs concurrence',
    },
    {
      name: 'FAKS',
      img: './assets/images/logo-faks-2022.png',
      link: 'https://web.faks.co/',
      authorizeGroup: 'pfa.autres-outils',
      tooltipMessage: 'Outil de suivi des opérations commerciales',
    },
    {
      name: 'Hygiestore',
      img: './assets/images/Logo-HygieStore-915x300.png',
      link: 'https://hygiestore.fr',
      authorizeGroup: 'pfa.autres-outils',
      tooltipMessage: 'La solution centralisée pour vos approvisionnements',
    },
    {
      name: 'MyTeam',
      img: './assets/images/logo-myteam.png',
      link: 'https://myteam-pharmacie.fr/',
      authorizeGroup: 'pfa.autres-outils',
      tooltipMessage: 'Outil de suivi rh et planification de lofficine',
    },
    {
      name: 'MyTeam',
      img: './assets/images/logo-myteam.png',
      link: 'https://myteam-pharmacie.fr/',
      authorizeGroup: 'pfa-gpo.autres-outils',
      tooltipMessage: 'Outil de suivi rh et planification de lofficine',
    },
    {
      name: 'Hygie31Academy',
      img: './assets/images/logo-hygie31-academy.jpg',
      link: 'https://hygieacademy.com/',
      authorizeGroup: 'pfa-gpo.autres-outils',
      tooltipMessage: "L'organisme de formation d'Hygie31",
    },
    {
      name: 'Laf Academy',
      img: './assets/images/logo-lafAcademy.png',
      link: 'https://laf-academy.com/',
      authorizeGroup: 'pfa.autres-outils',
      tooltipMessage: 'Outil de formation LafSanté',
    },
    {
      name: 'Apodis',
      img: '',
      link: 'https://pro.apodis-sante.com/login',
      authorizeGroup: 'pfa.autres-outils',
      tooltipMessage:
        "Solution pour simplifier l'interaction des équipes au comptoir avec les clients pour les services santé",
    },
    {
      name: 'Myris',
      img: './assets/images/logo-myris.png',
      link: 'https://myris.viatris.fr/',
      authorizeGroup: 'pfa.autres-outils',
      tooltipMessage: 'Outil de suivi de la substitution VIATRIS',
    },
  ];

  ngOnInit(): void {
    // Injecte l'URL de la brique "Pilotage Accords Commerciaux" depuis la configuration.
    // modules.gestac contient l'URL complète (page /pilotageaccordscommerciaux de GESTAC), par environnement.
    const pilotageAccordsBrick = this.linkToPageButtonsSuiviConditionsCommerciales.find(
      button => button.authorizeGroup === 'pfa.pilotage-accords-commerciaux',
    );
    if (pilotageAccordsBrick) {
      pilotageAccordsBrick.link = this.configService.config.modules.gestac;
    }

    this.userService
      .getSelectedAdherent()
      .pipe(
        takeUntil(this._destroying$),
        tap(adherent => {
          this.selectedAdherent = adherent;
        }),
      )
      .subscribe();

    this.userService.activite$.pipe(filter(v => v !== null)).subscribe(value => {
      this.activiteAdherent = value;
    });

    const currentUser = localStorage.getItem('currentUserCockpit');
    this.user = currentUser
      ? JSON.parse(currentUser)
      : { firstname: this.firstname, lastname: this.lastname };
    this.firstname = this.user.firstName;
    this.lastname = this.user.name;
    this.getOfficineData(this.user.email);

    this.initLinkByRoles();
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly userService: UserSessionService,
    private readonly configService: ConfigService,
  ) {
    // Initialisez le formulaire avec une propriété 'selectedOfficine'
    this.formSelect = this.formBuilder.group({
      selectedOfficine: null, // ou initialisez avec une officine par défaut si nécessaire
    });
  }

  /**
   * Récupère les données de l'officine pour un utilisateur donné.
   * @param {string} userEmail - L'identifiant de l'utilisateur.
   * @returns {void}
   */
  getOfficineData(userEmail: string): void {
    this.userService
      .getOfficine(userEmail, 'Home')
      .pipe(takeUntil(this._destroying$))
      .subscribe({
        next: data => {
          // Met à jour la liste des adhérents avec les données récupérées
          this.adherents = data;
          if (this.adherents.length > 0) {
            // Vérifie s'il y a des adhérents retournés
            if (this.selectedAdherent === null) {
              // Si aucun adhérent n'est sélectionné, sélectionne le premier adhérent par défaut
              this.formSelect.get('selectedOfficine')?.setValue(this.adherents[0]);
            } else {
              // Si un adhérent est déjà sélectionné, trouve son index dans la liste des adhérents
              const selectedIndex = this.adherents.findIndex(
                adherent => adherent.idAdherent === this.selectedAdherent?.idAdherent,
              );
              // Définit la valeur sélectionnée dans le formulaire en utilisant l'index trouvé
              if (selectedIndex !== -1) {
                this.formSelect.get('selectedOfficine')?.setValue(this.adherents[selectedIndex]);
              }
            }
          }
        },
        error: error => {
          // Gère les erreurs survenues lors de la récupération des données de l'officine
          console.error('file: accueil.component.ts - function: getOfficineData - ', error);
        },
      });
  }

  /**
   * Filter elements allowed to be seen based on user roles.
   *
   * @return {void} - This method filters and updates the arrays of link buttons based on user roles.
   */
  private initLinkByRoles() {
    // Filter elements allowed to be seen based on user roles.
    this.linkToPageButtonsAnimationsCommerciales =
      this.linkToPageButtonsAnimationsCommerciales.filter((button: any) =>
        this.displayLinkToPageButton(button.authorizeGroup),
      );
    this.linkToPageButtonsPilotage = this.linkToPageButtonsPilotage.filter((button: any) =>
      this.displayLinkToPageButton(button.authorizeGroup),
    );
    this.linkToPageButtonsAdmin = this.linkToPageButtonsAdmin.filter((button: any) =>
      this.displayLinkToPageButton(button.authorizeGroup),
    );
    this.externalLinkButtons = this.externalLinkButtons.filter((button: any) =>
      this.displayLinkToPageButton(button.authorizeGroup),
    );
    this.linkToPageButtonsSuiviConditionsCommerciales =
      this.linkToPageButtonsSuiviConditionsCommerciales.filter((button: any) =>
        this.displayLinkToPageButton(button.authorizeGroup),
      );
  }

  /**
   * Check if the given value is empty or null
   *
   * @param {string} value - The value to be checked
   * @return {boolean} Returns true if the value is empty or null, false otherwise
   */
  isEmptyOrNull(value: string): boolean {
    return value === null || value === '';
  }

  /**
   * Checks if user is authorized to view a button based on their group membership.
   *
   * @param {string} authorizeGroup - The group to authorize against.
   * @return {boolean} - Whether the user is authorized to view the button.
   */
  displayLinkToPageButton(authorizeGroup: string): boolean {
    return this.isEmptyOrNull(authorizeGroup) || this.user.groups.includes(authorizeGroup);
  }
}
